var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.snackQueue.length > 0)?_c(_vm.snackQueue[0].component,_vm._b({key:_vm.snackQueue[0].id,tag:"component",on:{"close":_vm.onClose}},'component',_vm.snackQueue[0].payload,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }